import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { getCookiesLocationDetails } from '../cookies/getCookiesLocationDetails';

const locationFormCookies = getCookiesLocationDetails();

export enum LocationTypeEnum {
  Home = 1,
  Work = 2,
  Other = 3,
}

export interface LocationDetails {
  name: string;
  type: number;
  details: string;
  street?: string;
  zip_code?: string;
  province?: string;
  typeArabicName?: string;
  typeEnglishName?: string;
  city?: string;
  country?: string;
  location: {
    latitude: number;
    longitude: number;
  };
}

type LocationState = {
  locationDetails: LocationDetails;
  setLocationDetails: (locationDetails: LocationDetails) => void;
};

// Create the store with persistence and devtools middleware
export const useLocationStore = create<LocationState>()(
  devtools(
    persist(
      (set) => ({
        locationDetails: {
          location: {
            latitude: locationFormCookies?.location.latitude,
            longitude: locationFormCookies?.location.longitude,
          },
          name: locationFormCookies?.name || '',
          type: locationFormCookies?.type || LocationTypeEnum.Home, // Default to Home
          details: locationFormCookies?.details,
          street: locationFormCookies?.street,
          zip_code: locationFormCookies?.zip_code,
          province: locationFormCookies?.province,
          city: locationFormCookies?.city,
          country: locationFormCookies?.country,
          typeArabicName: locationFormCookies?.typeArabicName,
          typeEnglishName: locationFormCookies?.typeEnglishName,
        },
        setLocationDetails: (locationDetails: LocationDetails) =>
          set((state) => ({
            ...state,
            locationDetails,
          })),
      }),
      {
        name: 'location-store', // The name used to store data in localStorage
      },
    ),
  ),
);
